import React, { useContext } from 'react';

import { LayoutContext } from 'contexts/LayoutContext';
import { PortfolioNative } from '../../components/portfolio/PortfolioNative';
import { PortfolioWeb } from '../../components/portfolio/PortfolioWeb';
import { usePortfolio } from './hooks/usePortfolio.hook';

interface PortfolioProps {}

export const Portfolio: React.FC<PortfolioProps> = () => {
  const portfolio = usePortfolio();
  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    return (
      <PortfolioNative
        overviewProps={portfolio.overviewProps}
        positionsProps={portfolio.positionsProps}
        myEarningsProps={portfolio.myEarningsProps}
        refreshPortfolio={portfolio.refreshPortfolio}
      />
    );
  }

  return (
    <PortfolioWeb
      overviewProps={portfolio.overviewProps}
      positionsProps={portfolio.positionsProps}
      layoutStyle={portfolio.layoutStyle}
      myEarningsProps={portfolio.myEarningsProps}
    />
  );
};
